'use client';

import SearchIcon from '@/icons/search.svg';
import { GeneralSettings, WagtailNavigation } from '@/types';
import ContactModal from '@components/Header/ContactModal';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { removeBaseUrl } from '@utils/url';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

type Props = {
  menu: WagtailNavigation[];
  settings: GeneralSettings | null | undefined;
};

// KI-Code, Here be dragons

function isActivePath(pathname: string | null, href: string) {
  if (!pathname) return false;
  const clean = href.replace(/\/$/, '');
  const current = pathname.replace(/\/$/, '');
  return current === clean || current.startsWith(clean + '/');
}

function DesktopNavigation(props: Props) {
  const { menu, settings } = props;
  const pathname = usePathname();

  return (
    <>
      <NavigationMenu.Root className='nav' aria-label='Hauptnavigation'>
        <NavigationMenu.List className='desktop-navigation__list'>
          {menu.map((item, index) => {
            const itemHref = removeBaseUrl(item.full_url);
            const parentActive = isActivePath(pathname, itemHref);
            return (
              <NavigationMenu.Item className='desktop-navigation__list-item' key={`${index}-${item.title}`}>
                {item.children.length ? (
                  <>
                    <NavigationMenu.Trigger
                      className='desktop-navigation__trigger'
                      data-active={parentActive || undefined}
                      onClick={e => {
                        // Prüfen, ob das Event von einer Maus ausgelöst wurde
                        if (e.nativeEvent instanceof PointerEvent && e.nativeEvent.pointerType === 'mouse') {
                          // Verhindert das standardmäßige "Close on Click"-Verhalten der Maus
                          e.preventDefault();
                        }
                      }}
                    >
                      {item.nav_title ? item.nav_title : item.title}
                    </NavigationMenu.Trigger>
                    <NavigationMenu.Content>
                      <NavigationMenu.Sub
                        role='list'
                        className='desktop-navigation__sub-menu'
                        defaultValue={index.toString()}
                      >
                        <NavigationMenu.List className='desktop-navigation__sub-menu-list'>
                          <NavigationMenu.Item
                            className='desktop-navigation__sub-menu-item'
                            key={`overview-${item.title}`}
                            value={index.toString()}
                          >
                            <NavigationMenu.Link
                              asChild
                              className='desktop-navigation__link'
                              active={pathname === itemHref}
                            >
                              <Link href={itemHref}>{'Zur Übersicht'}</Link>
                            </NavigationMenu.Link>
                          </NavigationMenu.Item>
                          {item.children.map((child, i) => {
                            const childHref = removeBaseUrl(child.full_url);
                            const childActive = isActivePath(pathname, childHref);
                            return (
                              <NavigationMenu.Item
                                className='desktop-navigation__sub-menu-item'
                                key={`${i}${item.title}`}
                                value={index.toString()}
                              >
                                <NavigationMenu.Link asChild className='desktop-navigation__link' active={childActive}>
                                  <Link href={childHref}>{child.nav_title ? child.nav_title : child.title}</Link>
                                </NavigationMenu.Link>
                              </NavigationMenu.Item>
                            );
                          })}
                        </NavigationMenu.List>
                      </NavigationMenu.Sub>
                    </NavigationMenu.Content>
                  </>
                ) : (
                  <NavigationMenu.Link className='desktop-navigation__link' asChild active={parentActive}>
                    <Link href={itemHref}>{item.nav_title ? item.nav_title : item.title}</Link>
                  </NavigationMenu.Link>
                )}
              </NavigationMenu.Item>
            );
          })}
        </NavigationMenu.List>
      </NavigationMenu.Root>
      <div className='nav-bar__buttons header__buttons'>
        {settings?.seminar_index_page ? (
          <Link href={removeBaseUrl(settings.seminar_index_page.full_url)} className='dialog-button menu-search'>
            <SearchIcon />
          </Link>
        ) : null}

        <ContactModal settings={settings} />
      </div>
    </>
  );
}

export default DesktopNavigation;
